import { Target } from '@nirvana/shared/dtos/types/alerts/common';

export function mergeTargets(firstList: Array<Target>, secondList: Array<Target>): Array<Target> {
  const includedTargetId: { [targetId: string]: boolean } = {};
  const resultList: Array<Target> = [];
  for (const targetList of [firstList, secondList]) {
    for (const target of targetList) {
      if (!includedTargetId[target.companyId]) {
        includedTargetId[target.companyId] = true;
        resultList.push(target);
      }
    }
  }
  return resultList;
}

export const DEFAULT_COMPANIES_LIMIT = 10;
export const DEFAULT_COMPANIES_PAGE = 1;
